import { render, staticRenderFns } from "./AsignarVendedoresBomba.vue?vue&type=template&id=4c652cc8&scoped=true&"
import script from "./AsignarVendedoresBomba.vue?vue&type=script&lang=js&"
export * from "./AsignarVendedoresBomba.vue?vue&type=script&lang=js&"
import style0 from "./AsignarVendedoresBomba.vue?vue&type=style&index=0&id=4c652cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c652cc8",
  null
  
)

export default component.exports